import { useEffect, useState } from 'react';
import { SortingSelectStyled } from './SortingSelect.style';

interface IProps {
  currentValue: any;
  type: any;
  textSize: any;
  onChange: any;
  options: any[];
  className?: string;
}

export const SortingSelect: React.FC<IProps> = ({
  currentValue,
  type,
  textSize,
  onChange,
  options,
  className,
}) => {
  const [optionsLocal, setOptions] = useState<any[]>([]);

  useEffect(() => {
    let selectOptions: any = [];

    options?.forEach?.(({ voices }) => {
      const partialOptions = voices.map(
        ({ label, link }: any, index: number) => {
          return {
            label,
            value: link,
            key: `sorting_${index}`,
          };
        }
      );
      selectOptions = selectOptions.concat(partialOptions);
    });

    setOptions(selectOptions);
  }, [options]);

  return (
    <SortingSelectStyled
      className={className}
      currentValue={currentValue}
      type={type}
      textSize={textSize}
      onChange={onChange}
      options={optionsLocal}
    />
  );
};
